import { render } from "./Button.vue?vue&type=template&id=79e15816&scoped=true"
import script from "./Button.vue?vue&type=script&lang=ts"
export * from "./Button.vue?vue&type=script&lang=ts"

import "./Button.vue?vue&type=style&index=0&id=79e15816&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-79e15816"

export default script